import React, { FC, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import LoadingButton from"../../components/LoadingButton/index";
import Button from "@material-ui/core/Button";

import { useParams, useLocation, useHistory } from "react-router-dom";
// import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { toMomentString } from "config/util";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Label,
  FormGroup,
  Form,
  Modal,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Col,
  Alert,
  Row,
  Spinner,
} from "reactstrap";

import { initReactI18next, useTranslation } from "react-i18next";

import validator from "validator";

import moment from "moment/moment";
import ReactBSAlert from "react-bootstrap-sweetalert";
import Select from "react-select";
import IntlTelInput from "react-intl-tel-input";

import ReactDatetime from "react-datetime";

import { t } from "../../services/i18n/index";

const AccountsAuthModal = ({
  loading,
  modal,
  close_modal,
  dispatch_info,
  active_wallet_id,
  active_symbol,
  dispatch_post_wallets_id_withdraw,
  active_wallets_deposit_balance,
  dispatch_post_wallets,
}) => {
  const [t, i18n] = useTranslation();
  const maps = useSelector((state) => state.reduce_get_maps);
  const theme = useTheme();
  const primary = theme.palette.primary.main;
  const [amount, set_amount] = useState("");
  const [label, set_label] = useState("");
  const [address, set_address] = useState("");
  return (
    <>
      <Modal
        className="modal-dialog-centered"
        size="md"
        isOpen={modal}
        toggle={() => {
          close_modal();
          set_label("");
          set_address("");
        }}
      >
        <div className="modal-header justify-content-center pb-0">
          <h4 className="title title-up mt-0">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => {
                close_modal();
                set_label("");
                set_address("");
              }}
            >
              <i className="nc-icon nc-simple-remove" />
            </button>

            {t("アドレスを登録")}
          </h4>
        </div>
        <div className="modal-body">
          <Container>
            <Row>
              <Col md="12">
                <p className="mb-4">
                  <b>{active_symbol}</b> {t("のアドレスを新しく登録します。")}
                </p>
                <div className="form-group bmd-form-group">
                  <TextField
                    value={label}
                    onChange={(event) => set_label(event.target.value)}
                    id="standard-basic"
                    label={t("ラベル")}
                    style={{ width: "100%" }}
                    variant="standard"
                  />
                </div>
                <div className="form-group bmd-form-group">
                  <TextField
                    value={address}
                    onChange={(event) => set_address(event.target.value)}
                    id="standard-basic"
                    label={t("アドレス")}
                    style={{ width: "100%" }}
                    variant="standard"
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="modal-footer justify-content-center">
          <Container>
            <Row className="buttons-row">
              <Col md="6" sm="6">
                <FormGroup>
                  <LoadingButton
                    onClick={(e) => {
                      e.preventDefault();
                      dispatch_post_wallets(
                        { symbol: active_symbol, label, address },
                        () => {
                          close_modal();
                          set_label("");
                          set_address("");
                        }
                      );
                    }}
                    pending={loading}
                    // variant="outlined"
                    variant="contained"
                    style={{
                      width: "100%",
                      backgroundColor: primary,
                      color: "white",
                    }}
                  >
                    {t("決定")}
                  </LoadingButton>
                </FormGroup>
              </Col>
              <Col md="6" sm="6">
                <FormGroup>
                  <LoadingButton
                    onClick={() => {
                      close_modal();
                      set_label("");
                      set_address("");
                    }}
                    pending={loading}
                    // variant="outlined"
                    variant="contained"
                    style={{
                      width: "100%",
                      // backgroundColor: primary,
                      // color: "white",
                    }}
                  >
                    {t("キャンセル")}
                  </LoadingButton>
                </FormGroup>
              </Col>
            </Row>
          </Container>
        </div>
      </Modal>
    </>
  );
};

export default AccountsAuthModal;
